import React from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

export default function BaseDataTable({ columns, data = [], mrtProps = {} }) {
  const {
    initialState,
    defaultColumn,
    muiTableContainerProps,
    ...restMrtProps
  } = mrtProps;

  const table = useMaterialReactTable({
    columns,
    data: Array.isArray(data) ? data : [],
    enableColumnActions: false,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enableGlobalFilter: false,
    enableRowActions: false,
    enableSorting: true,
    defaultColumn: {
      minSize: 80,
      size: 140,
      ...defaultColumn,
    },
    initialState: {
      pagination: { pageIndex: 0, pageSize: 5 },
      ...initialState,
    },
    muiTableContainerProps: {
      sx: { maxHeight: 560 },
      ...muiTableContainerProps,
    },
    muiTableHeadCellProps: {
      sx: {
        fontWeight: 700,
        fontSize: "0.85rem",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        fontSize: "0.85rem",
      },
    },
    ...restMrtProps,
  });

  return <MaterialReactTable table={table} />;
}
